import { render, staticRenderFns } from "./NovelGroupAddDialog.vue?vue&type=template&id=6cbd4712&scoped=true"
import script from "./NovelGroupAddDialog.vue?vue&type=script&lang=ts"
export * from "./NovelGroupAddDialog.vue?vue&type=script&lang=ts"
import style0 from "./NovelGroupAddDialog.vue?vue&type=style&index=0&id=6cbd4712&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbd4712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cbd4712')) {
      api.createRecord('6cbd4712', component.options)
    } else {
      api.reload('6cbd4712', component.options)
    }
    module.hot.accept("./NovelGroupAddDialog.vue?vue&type=template&id=6cbd4712&scoped=true", function () {
      api.rerender('6cbd4712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/NovelGroupAddDialog.vue"
export default component.exports